class ImageSlider {
    constructor(el) {

        // parent (in this case $('.image-slider'))
        this.parent = $(el);

        // slider
        this.slider = this.parent.find('.image-slider__slides');
        this.slides = this.slider.find('.image-slider__slide');

        // slide controls
        this.slideCounter = this.parent.find('.image-slider__count');
        this.slideCurrentCount = this.parent.find('.image-slider__count-current');
        this.slideTotalCount = this.parent.find('.image-slider__count-total');
        this.slideControls = this.parent.find('.image-slider__controls');

        // slide details
        this.caption = this.parent.find('.image-slider__caption');
        this.credits = this.parent.find('.image-slider__credits');

        // meta / info buttons
        this.info = this.parent.find('.image-slider__info');

        this.slides.each((index, slide) => {
            const $slide = $(slide);
            const caption = $slide.find('.image-slider__slide-caption');
            const credits = $slide.find('.image-slider__slide-credits').html();

            caption.append(`<span class="image-slider__hidden-credits">&nbsp;Credit: ${credits}</span>`);
        });

        this.slider
            .on('init', this.bindData.bind(this))
            .on('init', () => this.parent.addClass('slick-initialized'))
            .slick()
            .on('afterChange', this.bindData.bind(this));

        $(document)
            .on('click', '.image-slider__button--prev', this.handlePrevClick.bind(this))
            .on('click', '.image-slider__button--next', this.handleNextClick.bind(this))
            .on('click', '.image-slider__info', this.toggleMetaDetails.bind(this));
    }

    bindData(e, slick) {
        const currentSlide = $(slick.$slides[slick.currentSlide]);
        const currentCaption = currentSlide.find('.image-slider__slide-caption').html();
        const currentCredits = currentSlide.find('.image-slider__slide-credits').html();

        if (slick.slideCount <= 1) {
            this.slideControls.hide();
            this.slideCounter.hide();
        }

        this.slideCurrentCount.text(slick.currentSlide + 1);
        this.slideTotalCount.text(slick.slideCount);

        this.caption.html(currentCaption || '');
        this.credits.html(currentCredits || '');
    }

    handlePrevClick(e) {
        e.preventDefault();

        this.slider.slick('slickPrev');
    }

    handleNextClick(e) {
        e.preventDefault();

        this.slider.slick('slickNext');
    }

    toggleMetaDetails(e) {
        e.preventDefault();

        $(e.currentTarget).closest('.image-slider__meta').toggleClass('image-slider__meta--visible');
    }
}

$(() => {
    $.fn.imageSlider = function() {
        $(this).each((index, slider) => new ImageSlider(slider));
    };
});
